import { render, staticRenderFns } from "./DataTablePageSize.vue?vue&type=template&id=9880d754&"
import script from "./DataTablePageSize.vue?vue&type=script&lang=js&"
export * from "./DataTablePageSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports